"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _sizes = require("HubStyleTokens/sizes");

var _componentProp = require("../utils/propTypes/componentProp");

var NavItemLabel = _styledComponents.default.span.withConfig({
  displayName: "UINavItemLabel__NavItemLabel",
  componentId: "sc-1424a5s-0"
})(["align-items:center;display:flex;flex-grow:1;width:100%;"]);

var Count = _styledComponents.default.span.withConfig({
  displayName: "UINavItemLabel__Count",
  componentId: "sc-1424a5s-1"
})(["margin-left:auto;padding-left:", ";"], _sizes.NAV_ITEM_INNER_SPACING_X);

var _default = (0, _createReactClass.default)({
  displayName: 'UINavItemLabel',
  propTypes: {
    children: _propTypes.default.node,
    count: _propTypes.default.node
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        count = _this$props.count,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "count"]);
    return _react.default.createElement(NavItemLabel, Object.assign({}, rest, {
      className: className
    }), _react.default.createElement(_react.Fragment, null, children), (0, _componentProp.isRenderable)(count) && _react.default.createElement(Count, null, count));
  }
});

exports.default = _default;
module.exports = exports.default;